import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useEffect, useState } from "react";
import { functions } from "@poseidon/firebase/firebase";
import { floorPence } from "@poseidon/utils/currency";

const mapResult = (data) => {
  const payments = data.schedule.payments.reduce((agg, payment) => {
    const last = agg[agg.length - 1];
    const amount = floorPence(payment.payment);
    if (floorPence(last?.amount) === amount) {
      const rest = agg.slice(0, -1);
      return [
        ...rest,
        {
          ...last,
          count: last?.count + 1,
        },
      ];
    }
    return [
      ...agg,
      {
        amount: amount,
        count: 1,
      },
    ];
  }, []);
  return {
    ...data.schedule.parameters,
    startDate: new Date(data.schedule.parameters.startDate),
    payments,
  };
};
export const useReschedulePreview = (scheduleId) => {
  const [executeCallable, loading, error] = useHttpsCallable(
    functions,
    "reschedulePreview"
  );
  const [complete, setComplete] = useState(false);
  const [preview, setPreview] = useState(false);
  useEffect(() => {
    setComplete(false);
  }, [scheduleId]);
  const reschedulePreview = async ({
    mode,
    addonRate,
    term,
    repayment,
    holidayMonths,
    lumpSum,
    balloon,
  }) => {
    try {
      const result = await executeCallable({
        ...(mode === "term" ? { term } : {}),
        ...(mode === "payment" ? { repayment } : {}),
        // omit to preserve the existing balloon; send a value to override it
        ...(balloon !== "" && balloon != null
          ? { balloon: Number(balloon) }
          : {}),
        mode,
        scheduleId,
        addonRate,
        holidayMonths,
        lumpSum,
      });
      setComplete(true);
      if (!result?.data?.success) {
        throw new Error("Error rescheduling");
      }
      setPreview(mapResult(result.data));
      return true;
    } catch (err) {
      setComplete(false);
      setPreview(undefined);
      return false;
    }
  };
  return {
    loading,
    error,
    preview,
    success: !loading && !error && complete,
    reschedulePreview,
  };
};
